import { ImageAttachment, VideoAttachment } from '../lib/entities';

// posterFile is optional and only used for video attachments
interface FileUploadProps {
	onUpload?: (mediaFile: File, posterFile?: File | null) => Promisable<VideoAttachment | ImageAttachment>;
	afterUpload?: (attachment: VideoAttachment | ImageAttachment) => void;
}

export const useFileUpload = ({ onUpload, afterUpload }: FileUploadProps) => {
	return async (mediaFile: File, posterFile?: File | null): Promise<VideoAttachment | ImageAttachment> => {
		if (!onUpload) {
			throw new Error('onUpload handler not provided');
		}
		const attachment = await onUpload(mediaFile, posterFile);
		afterUpload?.(attachment);
		return attachment;
	};
};
